import axios from "axios";

const BASE = import.meta.env.VITE_API_URL ?? "http://localhost:3000";

export const axiosInstance = axios.create({ baseURL: BASE });

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("lp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// The api throws 401 for both a missing and an expired/invalid JWT (see api-auth.guard.ts).
// Without this, an expired token leaves every page stuck: Refine-hook pages show a generic
// error toast forever and raw axiosInstance calls (snippets, projects, settings, cli-auth)
// have no error handling at all, so their loading state never resolves. Clearing the stale
// token and hard-redirecting guarantees every call site recovers into a working login screen,
// not just the ones going through Refine's own data hooks.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined;
    if (status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("lp_token");
      localStorage.removeItem("lp_user");
      const returnTo = `${window.location.pathname}${window.location.search}`;
      window.location.href = `/login?returnTo=${encodeURIComponent(returnTo)}`;
    }
    return Promise.reject(error);
  }
);
